import EMPTY_CART from "@assets/image/empty_cart.png"
import { Text } from "@medusajs/ui"
import Image from "next/image"
import { ExtendedStoreCart } from "types/global"
import ItemsCartDrawer from "./items"

type Props = {
  cart: ExtendedStoreCart | null
}

function ContentCart({ cart }: Props) {
  if (!cart?.items?.length)
    return (
      <div className="flex flex-col justify-center h-2/3 items-center">
        <Image src={EMPTY_CART} alt={""} />
        <Text className="text-[#656C78]">
          Chưa có sản phẩm nào trong giỏ hàng!
        </Text>
      </div>
    )
  return <ItemsCartDrawer cart={cart} />
}

export default ContentCart
